import { EntityReferences } from "../models/mappers";
import { EntityName } from "./entityNames";
import { AnyEntityField } from "./metadata";

export const contractRequestFields = [
  "ggp_contractrequestid", // UID
  "statecode", // State - Active/Inactive
  "ggp_AccountId", // Reference
  "gaming_ContractTypeId", // Reference
  "gaming_ContractSubTypeId", // Reference
  "ggp_status", // Choice
  "gaming_contractaccountname", // Text
  "gaming_contractapistatus ",
  "gaming_contractapigametitle", // Text
  "gaming_contractfilename", // Text
  "gaming_contractfullfilename",
  "gaming_contractaddressblock1", // Text
  "gaming_contractaddressblock2", // Text
  "gaming_contractaddressblock3", // Text
  "gaming_PrimarySignatoryId", // Text
  "gaming_address1_telephone1",
  "gaming_AdditionalCCdContactId",
  "gaming_additionalccdcontact2id",
  "gaming_additionalccdemail4",
  "gaming_additionalccdemail5",
  "gaming_additionalccdemail6",
  "gaming_additionalccdemail7",
  "gaming_additionalccdemail8",
  "gaming_additionalccdemail9",
  "gaming_additionalccdemail10",
  "gaming_contractname",
  "gaming_effectivedate",
  "gaming_expirationdate",
  "gaming_contractapilceexpirationdate",
  "gaming_contractvendoraccountusecreate",
  "gaming_contractapiresponse",
  "gaming_contractapistatus",
  "gaming_contractapilcecontractid",
  "gaming_contractvendornumber",
  "ggp_dealpointid",
  "gaming_contractapiresponse ",
  "gaming_contractapilcecontractid",
  "gaming_RequestorId",
  "gaming_contractvendoridtouse",
  "gaming_contractvendornametosearch",
  "gaming_contractcountvendoraccounts",
  "gaming_contractapiaccountlookupresults",
  "gaming_msvendornumber",
  "gaming_contractapilcestatus",
  "gaming_contractexecuteddate",
  "gaming_contractsentdate",
  "gaming_ContractManagerID",
  "gaming_contractresenddate",
  "gaming_ContractAutoConfigId",
  "gaming_contractautomationtype",
  "gaming_ContractRegionId",
  "gaming_gdkeffectivedate",
  "gaming_adaeffectivedate",
  "gaming_contractapirequest",
  "gaming_ContractCoordinatorId",
  "gaming_contracthasmultipletitles",
  "gaming_contracttooldescription",
] as const;

export const contractRequestReferences: EntityReferences<EntityName.ggp_contractrequest> = {
  [EntityName.account]: ["ggp_AccountId"],
  [EntityName.gaming_contracttype]: ["gaming_ContractTypeId"],
  [EntityName.contact]: [
    "gaming_PrimarySignatoryId",
    "gaming_AdditionalCCdContactId",
    "gaming_additionalccdcontact2id",
  ],
  [EntityName.user]: [
    "gaming_RequestorId",
    "gaming_ContractManagerID",
    "gaming_ContractCoordinatorId",
  ],
  [EntityName.gaming_contractsubtype]: ["gaming_ContractSubTypeId"],
  [EntityName.gaming_contractautoconfig]: ["gaming_ContractAutoConfigId"],
  [EntityName.gaming_contractregion]: ["gaming_ContractRegionId"],
};

export const contractRequestKey: AnyEntityField<EntityName.ggp_contractrequest> =
  "ggp_contractrequestid";
